import { render } from "./CommunicationQuiz.vue?vue&type=template&id=0d2be42d&scoped=true&ts=true"
import script from "./CommunicationQuiz.vue?vue&type=script&lang=ts"
export * from "./CommunicationQuiz.vue?vue&type=script&lang=ts"

import "./CommunicationQuiz.vue?vue&type=style&index=0&id=0d2be42d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2be42d"]])

export default __exports__